import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";

export const PasswordRules = ({ formik }) => {
  const getPasswordValidationStyles = (
    type: "number" | "lowercase" | "uppercase" | "special"
  ) => {
    const isTouched = formik.touched?.password;
    const isValid =
      !formik.errors?.password?.includes(type) && formik.values?.password;

    if (!isTouched && !isValid) {
      return {
        color: "#65748B",
        icon: <CloseIcon />,
      };
    }

    return isValid
      ? { color: "#14B8A6", icon: <CheckIcon /> }
      : { color: "#D14343", icon: <CloseIcon /> };
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography color="textSecondary" variant="body2">
        Password should contain:
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          color: getPasswordValidationStyles("number").color,
          "& svg": { fontSize: "1rem" },
        }}
      >
        {getPasswordValidationStyles("number").icon}
        <Typography variant="body2" sx={{ ml: "0.25rem" }}>
          at least 1 number
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          color: getPasswordValidationStyles("uppercase").color,
          "& svg": { fontSize: "1rem" },
        }}
      >
        {getPasswordValidationStyles("uppercase").icon}
        <Typography variant="body2" sx={{ ml: "0.25rem" }}>
          at least 1 uppercase letter
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          color: getPasswordValidationStyles("lowercase").color,
          "& svg": { fontSize: "1rem" },
        }}
      >
        {getPasswordValidationStyles("lowercase").icon}
        <Typography variant="body2" sx={{ ml: "0.25rem" }}>
          at least 1 lowercase letter
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          color: getPasswordValidationStyles("special").color,
          "& svg": { fontSize: "1rem" },
        }}
      >
        {getPasswordValidationStyles("special").icon}
        <Typography variant="body2" sx={{ ml: "0.25rem" }}>
          at least 1 special character
        </Typography>
      </Box>
    </Box>
  );
};
